import { render, staticRenderFns } from "./SplitOrderReferenceButton.vue?vue&type=template&id=0916745b&"
import script from "./SplitOrderReferenceButton.vue?vue&type=script&lang=js&"
export * from "./SplitOrderReferenceButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports